<template>
  <button v-bind:class="{ stake: true, selected: isSelected }" @click="onClick">
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "StakeButton",
  props: {
    onClick: Function,
    label: String,
    isSelected: Boolean
  }
};
</script>

<style scoped>
.stake {
  border-radius: 16px;
  border: none;
  height: 32px;
  padding: 0 14px;
  font-size: 12px;
  line-height: 15px;
  font-weight: 600;
  background-color: #ECECEC;
  color: #4a4a4a;
  outline: none;
  cursor: pointer;
  transition: background-color 0.5s;
}
.stake:not(.selected):hover {
  background-color: #ffffff;
}
.selected {
  background-color: #ffffff;
  box-shadow: 0 4px 24px 9px rgba(0,0,0,0.08);
}
</style>
